/**
 * Sorted unique values (filter/option lists). Defaults to lexicographic `.sort()`, so pass a comparator for numbers,
 * or e.g. `(a, b) => a.localeCompare(b)` where locale-aware ordering matters.
 */
export const uniqueSorted = <T>(values: Iterable<T>, compare?: (a: T, b: T) => number): T[] => [...new Set(values)].sort(compare);

/** The strings in `value` when it's an array, or none when it isn't */
export const asStrings = (value: unknown): string[] => (Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : []);

export const chunk = <T>(items: readonly T[], size: number): T[][] =>
  Array.from({ length: Math.ceil(items.length / size) }, (_, index) => items.slice(index * size, (index + 1) * size));

/** `Map.groupBy` until the TS lib target reaches ES2024. */
export const groupBy = <T>(items: Iterable<T>, keyOf: (item: T) => string): Map<string, T[]> => {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const key = keyOf(item);
    const group = groups.get(key);
    if (group) group.push(item);
    else groups.set(key, [item]);
  }
  return groups;
};
